import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📙',
    title: 'Tomo 1 — Fuerza Base & Estabilidad',
    sessions: '61 sesiones',
    months: 'Meses 1 y 2',
    desc: 'Para construir cimientos sólidos y fuerza estructural en tus alumnos desde el primer día.',
    color: 'bg-[#FF6B00]',
    borderColor: 'border-t-[#FF6B00]'
  }, {
    emoji: '📘',
    title: 'Tomo 2 — Potencia & Transferencia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 3 y 4',
    desc: 'Para desarrollar velocidad, explosividad y transferencia directa a gestos deportivos.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Tomo 3 — Resistencia Metabólica & Fat Loss',
    sessions: '61 sesiones',
    months: 'Meses 5 y 6',
    desc: 'Para quemar grasa y llevar el acondicionamiento metabólico de tu grupo al límite.',
    color: 'bg-[#EF4444]',
    borderColor: 'border-t-[#EF4444]'
  }, {
    emoji: '📓',
    title: 'Tomo 4 — Hipertrofia Funcional',
    sessions: '61 sesiones',
    months: 'Meses 7 y 8',
    desc: 'Para ganar masa muscular de forma funcional con protocolos de hipertrofia adaptados.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📗',
    title: 'Tomo 5 — Agilidad & Rendimiento Atlético',
    sessions: '61 sesiones',
    months: 'Meses 9 y 10',
    desc: 'Para mejorar la coordinación, agilidad y capacidad atlética general en cualquier nivel.',
    color: 'bg-[#10B981]',
    borderColor: 'border-t-[#10B981]'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — Especialización & Desafíos Finales',
    sessions: '60 sesiones',
    months: 'Meses 11 y 12',
    desc: 'Para poner a prueba todo lo aprendido en el año con desafíos y benchmarks competitivos.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }];
  const features = ['Objetivo del día claro y visible', 'Materiales con íconos visuales', 'Warm-up listo para dictar', 'Parte principal con series, reps y tiempos', '3 versiones: Principiante, Intermedio, Avanzado', 'Cool down específico de la sesión', 'Tip del Coach al final de cada hoja', 'Una sesión por página — sin hojas complicadas'];
  const featureChips = ['✅ Gym + Box + Funcional', '✅ Programa anual listo', '✅ Versiones A/B/C por nivel', '✅ Warm-ups y cool downs', '✅ 365 sesiones listas', '✅ Equipamiento básico'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18" data-mp="gk525dpgi34z">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19" data-mp="gh95dspchki4">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20" data-mp="liq4pjs6kywl">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #D4A41C 0%, #F0BE2A 50%, #D4A41C 100%)',
          color: '#1A1303',
          boxShadow: '0 0 20px rgba(212,164,28,0.4)'
        }} data-id="element-21" data-mp="vmna1hicatwe">
            🏆 Sistema n°1 para profesores de Funcional
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[44px] text-[32px]" data-id="element-22" data-mp="1eez8vu9sbd1s">
          🏆 MEGAPACK FUNCIONAL <span className="text-brandOrange" data-id="element-23" data-mp="14ma2hdt3cpdb">365™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24" data-mp="10lge6jbql8jw">
          6 Tomos + 5 Bonos — 365 sesiones listas · Un año completo · Todo
          resuelto.
        </p>
      </FadeIn>

      {/* Colored book strip with emoji */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25" data-mp="1sbcsb8xvpoiw">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26" data-mp="1cu3doqt8jsdt">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[44px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27" data-mp="1hu8zvrgqkmoi" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28" data-mp="1vm5ohlj74eg5"></div>
              <span className="font-sans font-bold uppercase tracking-[1px] text-[8px] md:text-[10px] leading-tight drop-shadow-md relative z-10" data-id="element-29" data-mp="20iw2827j2xye">
                Tomo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30" data-mp="1qsb5ylfbu5in">
          <span className="inline-block bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-31" data-mp="2ejqben2eh2y4">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32" data-mp="7td81wdx4zqo">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33" data-mp="2vlktfo7y1st">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandOrange/10 text-brandOrange border border-brandOrange/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34" data-mp="hndkykffz99y" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35" data-mp="3v0yu5vi8saw9">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandOrange/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36" data-mp="3uycpc3mqk9hq">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandOrange" data-id="element-37" data-mp="1a9otqid7cghu">
            📦 Lo que recibes:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38" data-mp="1cetm228ipx58">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39" data-mp="1mchqjjvxej0l" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b transition-all border-t-[3px] ${isOpen ? 'border-brandOrange shadow-[0_0_40px_rgba(255,107,0,0.2)]' : `border-x-line border-b-line ${tomo.borderColor}`}`} aria-expanded={isOpen} data-id="element-40" data-mp="1md9cs43mv4e7">
                <div className="flex items-start justify-between gap-3" data-id="element-41" data-mp="13lqeubogugj1">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42" data-mp="18cghhh5ic5a1">
                    <div className="text-2xl md:text-4xl shrink-0" data-id="element-43" data-mp="axccjjqcgy1o">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44" data-mp="fvm8hwjw82oc">
                      <h3 className="font-sans font-bold text-[15px] md:text-xl text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45" data-mp="fuktjgzraw1c">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46" data-mp="2p5vdrlc2wcid">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandOrange bg-brandOrange/10 px-2 py-0.5 rounded" data-id="element-47" data-mp="2k57nj1vobzp7">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-48" data-mp="2a94erd6bh2ta">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandOrange text-white rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49" data-mp="1webqnqcd2eb3">
                    {isOpen ? <Minus size={14} data-id="element-50" data-mp="3bbwewmaudgkj" /> : <Plus size={14} data-id="element-51" data-mp="3bdr3qbp8hstw" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52" data-mp="3feb2fjpgh4i5">
                  <div className="overflow-hidden" data-id="element-53" data-mp="36dcu4p7ziatr">
                    <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-54" data-mp="36c1p6m2syx12">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-55" data-mp="2io0k5n4u1yqe">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-56" data-mp="2iotoyik8ee5w">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-57" data-mp="2nnn1a7ns7z4h">
            Cada sesión incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-58" data-mp="2dp787z572fsc">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-59" data-mp="1u3x9o17ffoz3" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-60" data-mp="1q1k69jg5k35h" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-61" data-mp="240s70gryrjbs">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-62" data-mp="1z4bihlgur2y6">
            <p className="font-sans font-bold text-base md:text-xl text-brandOrange leading-snug" data-id="element-63" data-mp="2d0f974siot5w">
              Abres el TOMO, eliges la sesión y dictas. Así de simple. 365
              clases de alto rendimiento. Listas desde hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🔧',
    title: 'Kit de Adaptaciones Rápidas',
    desc: 'Versión A, B y C para cada ejercicio. La misma clase para grupos mixtos.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/uiThw6MmkhzjeK1izuU75Y/BONO_1.webp'
  }, {
    num: '02',
    icon: '🔥',
    title: 'Banco de 20 Warm-Ups Listos',
    desc: 'Calentamientos específicos por tipo de sesión. Express y completos.',
    value: 'USD $8',
    image: 'https://cdn.magicpatterns.com/uploads/mznfrhWEab51iuJMDAVGxh/BONO_2.webp'
  }, {
    num: '03',
    icon: '🧊',
    title: 'Banco de 20 Cool Downs y Cierres',
    desc: 'Termina cada clase con profesionalismo. Scripts de cierre incluidos.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/8BmieAD5enaNdNDJrabV5c/BONO_3.webp'
  }, {
    num: '04',
    icon: '🎤',
    title: '50 Frases y Scripts de Coaching',
    desc: 'Las palabras exactas para motivar, corregir y liderar tu clase.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/vtM6h2S7SiZGPcTo7Jag9s/BONO_4.webp'
  }, {
    num: '05',
    icon: '📊',
    title: 'Planilla Maestra del Sistema',
    desc: 'Vista anual, mensual, semanal y diaria. Sin improvisar.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/eBSsoCAHqPctuYrAtz3Yxa/BONO_5.webp'
  }];
  return <Section className="bg-bg-alt" data-id="element-64" data-mp="4zaddvloeocm">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-65" data-mp="4w4oagd1rmgw">
        <h2 className="font-display font-extrabold uppercase md:text-[44px] text-txt-primary mb-2 md:mb-4 text-[34px]" data-id="element-66" data-mp="8zatdkofb7ls">
          + 5 BONOS <span className="text-brandOrange" data-id="element-67" data-mp="dsx7zie5dlk8">ESTRATÉGICOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-68" data-mp="ipdwidp9e1xu">
          Materiales exclusivos — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-69" data-mp="sp4tqn57ev1m">
        {bonuses.map((bono, i) => <FadeIn key={bono.num} delay={Math.min(i * 0.05, 0.2)} data-id="element-70" data-mp="wodnvt45ouxp" data-mpi={i}>
            <article className="bg-bg-card rounded-[16px] border border-line border-l-[3px] border-l-brandOrange h-full overflow-hidden flex gap-3 p-3 md:gap-4 md:p-4" data-id="element-71" data-mp="2ufyb9fyr5mc9">
              <img src={bono.image} alt={`Portada del bono ${bono.num}: ${bono.title}`} loading="lazy" decoding="async" width={128} height={171} className="w-24 self-start aspect-[3/4] shrink-0 rounded-[10px] object-cover border border-white/10 md:w-32" data-id="element-72" data-mp="2yiuy5ivbs4m0" />
              <div className="min-w-0 flex flex-1 flex-col" data-id="element-73" data-mp="eo13kjx55z9x">
                <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-74" data-mp="alwabmalv4nt">
                  <div className="flex items-center gap-1.5" data-id="element-75" data-mp="ao0lmpau35y4">
                    <span className="text-lg md:text-xl" data-id="element-76" data-mp="ojumqm5d8r0o">🎁</span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange" data-id="element-77" data-mp="jn4905h1a7if">
                      BONO {bono.num}
                    </span>
                  </div>
                  <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-78" data-mp="td70204lhbe4">{bono.icon}</span>
                </div>
                <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-79" data-mp="17cgfgxkz81h1">
                  {bono.title}
                </h3>
                <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-80" data-mp="1lzni8g0b5t4u">
                  {bono.desc}
                </p>
                <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-81" data-mp="1cygzs1e3m88y">
                  <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-82" data-mp="1gyhpii6ne5vb">
                    {bono.value}
                  </span>
                  <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-83" data-mp="17ykuzzxkucsc">
                    GRATIS
                  </span>
                </div>
              </div>
            </article>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-84" data-mp="k9ifoyqf0w10">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-85" data-mp="p7bidhsif7wj">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-86" data-mp="h9ro2pon9lxf">
          USD $40
        </p>
        <p className="font-display font-black text-[24px] md:text-[44px] leading-[1.1] mb-1 md:mb-2 text-[#22C55E]" data-id="element-87" data-mp="7hc8fz0tl9fp">
          🎁 GRATIS — CON TU MEGAPACK
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-88" data-mp="3e626rdpji98">
          Incluidos en tu MEGAPACK, sin costo extra.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-89" data-mp="3kqgp5w5gk3fp">
      <div className="max-w-[1100px] mx-auto" data-id="element-90" data-mp="3godcx5aysutd">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-91" data-mp="1iwr7d8clabdg">
          <div className="rounded-[20px] border-2 border-brandOrange p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-92" data-mp="1iwhend05tq42">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange" data-id="element-93" data-mp="2wssihdbq1uv9">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white animate-glow-button" data-id="element-94" data-mp="36k58dzdymayn">
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-95" data-mp="3aj5np7x8avgw">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-96" data-mp="2itt3yyhxawct">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-97" data-mp="2ruqymq6h1riq">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-98" data-mp="72p6idaygjjb">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-99" data-mp="1z59y2hm3xi3i">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-100" data-mp="2867v2fy4opcl">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-101" data-mp="1fhkegxobqo5d">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[40px] md:text-[52px] py-2 text-brandOrange flex items-center" data-id="element-102" data-mp="1pfgn9itsh70b">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandOrange rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(255,107,0,0.4)]" data-id="element-103" data-mp="11ob9rabbmqt6">
                <div className="font-display font-black text-[40px] md:text-[52px] text-brandOrange leading-none" data-id="element-104" data-mp="38ctr0jcsovuy">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandOrange mt-1" data-id="element-105" data-mp="2zf16n0s7uy0p">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold leading-snug" data-id="element-106" data-mp="3r2jj2yp6b3j6">
              <AlertTriangle size={20} data-id="element-107" data-mp="3i47u113ygdsu" />
              <span data-id="element-108" data-mp="3i36821lei6wc">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-109" data-mp="3n29dvo97gh5d">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-110" data-mp="26p2e2vetcira">
                <span className="flex items-center gap-2" data-id="element-111" data-mp="2box5d02i3acv">
                  <span className="w-2 h-2 rounded-full bg-brandOrange animate-pulse" data-id="element-112" data-mp="32dz3glwamgvc"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandOrange font-bold" data-id="element-113" data-mp="2yb2fefnzhsk0">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-114" data-mp="2tdj4npqhvxwt">
                <div className="bg-brandOrange h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-115" data-mp="2ofr09w8nyjbq"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-116" data-mp="3h2vdgohwu3yl">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const includes = [{
    icon: '📚',
    label: '6 Tomos Completos',
    detail: '365 sesiones listas para dictar',
    price: 'USD $39'
  }, {
    icon: '🎁',
    label: '5 Bonos Exclusivos',
    detail: 'Adaptaciones, warm-ups, cierres y scripts',
    price: 'USD $40'
  }];
  return <Section className="bg-bg-alt !pt-6 !pb-8 md:!pt-12 md:!pb-14" id="pricing" data-id="element-117" data-mp="b8rnsqscts8u">
      <div className="max-w-lg mx-auto" data-id="element-118" data-mp="g5rmuhqsduqg">
        <FadeIn className="text-center mb-5 md:mb-7" data-id="element-119" data-mp="g8nhnx7c83ao">
          <p className="font-sans text-[12.5px] md:text-[15px] text-txt-body" data-id="element-120" data-mp="l5e6pa14e988">
            Estás a un paso de resolver todas tus clases...
          </p>
          <h2 className="font-display font-extrabold uppercase text-[32px] md:text-[44px] leading-[1.02] text-txt-primary mt-2 max-w-[15ch] md:max-w-none mx-auto" data-id="element-121" data-mp="q2e3svfzs1n7">
            OFERTA ESPECIAL DE{' '}
            <span className="text-brandOrange" data-id="element-122" data-mp="z32htq5dy203">LANZAMIENTO</span>
          </h2>
          <p className="font-sans text-[11.5px] md:text-[14px] leading-[1.45] text-txt-muted mt-1.5" data-id="element-123" data-mp="13wxa3hz23pas">
            Tomos, bonos y 365 sesiones listas en un solo acceso.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-124" data-mp="1dw6245ad2tui">
          <div className="relative rounded-[20px] md:rounded-[24px] border-2 border-brandOrange bg-bg-card px-4 pt-7 pb-4 md:px-7 md:pt-9 md:pb-6 shadow-[0_0_60px_rgba(255,107,0,0.22),inset_0_0_30px_rgba(255,107,0,0.03)]" data-id="element-125" data-mp="1hvwozxwroptr">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(255,107,0,0.5)]" data-id="element-126" data-mp="2maljodwcipi6">
              ⭐ MÁS ELEGIDO
            </div>

            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mb-3 md:mb-4" data-id="element-127" data-mp="30bebgqv9j6hl">
              Lo que incluye tu MEGAPACK
            </p>

            <ul className="divide-y divide-line border-y border-line" data-id="element-128" data-mp="3a0fsmkdjntx5">
              {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5 md:py-3" data-id="element-129" data-mp="3f0ahkidre9fk">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-130" data-mp="3j25k1q7fesux">
                    <span className="text-[15px] md:text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-131" data-mp="3o0gspxlzixbk">
                      {item.icon}
                    </span>
                    <div className="min-w-0" data-id="element-132" data-mp="1ceoorgoiaupn">
                      <p className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug" data-id="element-133" data-mp="17eah3zqthms5">
                        {item.label}
                      </p>
                      <p className="font-sans text-[10.5px] md:text-[12.5px] leading-[1.35] text-txt-muted" data-id="element-134" data-mp="13ea2of3pxbl3">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                  <span className="font-sans font-bold text-[12.5px] md:text-[15px] line-through text-danger shrink-0" data-id="element-135" data-mp="1r29tff1151zo">
                    {item.price}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 text-center" data-id="element-136" data-mp="1hczzruqjfb9g">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-137" data-mp="1ha3ypxje86gs">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-138" data-mp="2a040hnill3ff">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandOrange/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-139" data-mp="2xv5w3wq8iecw">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-140" data-mp="2k4kdm94p06fj">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[46px] md:text-[64px] leading-none text-brandOrange mt-1" data-id="element-141" data-mp="2a5v69aafa4dj">
                $16{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-142" data-mp="2f3d6mcadjb9x">
                  USD
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-143" data-mp="258bh3fc6s76t">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-144" data-mp="3f5c5tu42dbq" />

            <div className="mt-4 md:mt-5" data-id="element-145" data-mp="1ny7l2gmiv6vs">
              <CTAButton href={PRODUCTS.megapack.checkoutUrl} fullWidth trackingProduct="megapack" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-146" data-mp="1nz0ujpcv8ahm">
                QUIERO EL MEGAPACK COMPLETO
              </CTAButton>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2.5 md:mt-3.5 font-sans text-[10px] md:text-[12.5px] text-txt-muted" data-id="element-147" data-mp="1sxkg3onjrk9g">
                <span data-id="element-148" data-mp="27kdnm7qtrlr3">🔒 Pago seguro</span>
                <span data-id="element-149" data-mp="22ndo6fohdh8y">⚡ Acceso en minutos</span>
                <span data-id="element-150" data-mp="22mly1kdnkbq2">🛡️ Garantía 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};